export default __webpack_public_path__ + "static/media/corentin.31935e18.jpg";